import React from "react";
const AppRadioButton = ({
  name,
  value,
  checked,
  onChange,
  title,
  description,
  disabled = false,
}) => {
  return (
    <label
      className={`flex gap-3 items-start transition
        ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}
        ${
          checked
            ? "border-blue-500"
            : disabled
              ? "border-gray-200"
              : "border-gray-200 hover:border-gray-300"
        }`}
    >
      {/* Radio */}
      <span className="relative mt-1">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={() => {
            if (!disabled) onChange(value);
          }}
          className="sr-only"
        />
        <span
          className={`w-5 h-5 rounded-full border flex items-center justify-center
            ${checked ? "border-blue-600" : "border-gray-400"}`}
        >
          {checked && (
            <span className="w-2.5 h-2.5 bg-blue-600 rounded-full" />
          )}
        </span>
      </span>

      {/* Text */}
      <div>
        <p className="font-normal text-gray-900 mb-0">{title}</p>
        {description && (
          <p className="text-sm text-gray-500">{description}</p>
        )}
      </div>
    </label>
  );
};

export default AppRadioButton;
